export default "__VITE_ASSET__DlGMIJ0o__"